import React from "react";
import useMediaQueries from "hooks/useMediaQueries.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";

const NotificationIcon = ({
  openNotifications,
  setOpenNotifications,
  countNewNotifications,
}) => {
  const { closeModal } = useModal();
  const { mobileCondition } = useMediaQueries();
  const { getTextByKey } = useContent();
  return (
    <div className="notifications-container">
      <button
        className="bell-icon"
        aria-label={countNewNotifications}
        onClick={() => {
          if (mobileCondition) closeModal();
          setOpenNotifications((prev) => !prev);
        }}
        alt={countNewNotifications || getTextByKey("notifications-title")}
        aria-label={
          countNewNotifications || getTextByKey("notifications-title")
        }
      >
        <span className={`${openNotifications ? "open-icon" : "close-icon"}`}>
          <i className="fas fa-bell"></i>
        </span>
        {countNewNotifications && countNewNotifications > 0 ? (
          <span className="new-notifications">{countNewNotifications}</span>
        ) : null}
      </button>
    </div>
  );
};

export default NotificationIcon;
